"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "54.78",
    height: "24",
    viewBox: "0 0 54.78 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0,15.2v4.63H8.49a.81.81,0,0,0,.66-.36,4.2,4.2,0,0,0-.06.62A3.91,3.91,0,1,0,15,16.76h3.87a3.91,3.91,0,1,0,4.06,0h3.63a.78.78,0,1,0,0-1.56H23.36V.8a.8.8,0,0,0-.8-.8H0V1.57H21.8V15.2Zm9.3,3.67V16.76H11A3.87,3.87,0,0,0,9.3,18.87Zm6,1.22A2.35,2.35,0,1,1,13,17.74,2.35,2.35,0,0,1,15.35,20.09Zm7.92,0a2.36,2.36,0,1,1-2.35-2.35A2.35,2.35,0,0,1,23.27,20.09Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M33,15.2V1.57h21.8V0H32.22a.8.8,0,0,0-.8.8V15.2H28.2a.78.78,0,1,0,0,1.56h3.63a3.92,3.92,0,1,0,4.06,0h3.87a3.9,3.9,0,1,0,5.93,3.33,4.2,4.2,0,0,0-.06-.62.79.79,0,0,0,.65.36h8.5V15.2ZM43.8,16.76h1.68v2.11A3.87,3.87,0,0,0,43.8,16.76Zm-2,1a2.35,2.35,0,1,1-2.35,2.35A2.35,2.35,0,0,1,41.78,17.74Zm-7.92,0a2.35,2.35,0,1,1-2.35,2.35A2.36,2.36,0,0,1,33.86,17.74Z"
  }));
};

exports["default"] = _default;